interface AnalyzeReport {
  key: string
  title: string
  text: string
  icon?: string
  fontIcon?: string
}

export const ANALYZE_REPORT: AnalyzeReport[] = [
  {
    key: "print",
    title: "ペーパーレス分析",
    text: "印刷に関わる業務を抽出・分析し、データを表示します。",
    icon: "/static/images/analyze/paperless.png",
    fontIcon: "file-alt",
  },
  {
    key: "work_style",
    title: "ワークスタイル分析",
    text: "リモートワークを抽出・分析し、オフィスワークとの比較データを表示します。",
    icon: "/static/images/analyze/remote.png",
    fontIcon: "file-alt",
  },
  {
    key: "member_application",
    title: "ITレポート(ユーザー)",
    text: "使用しているアプリケーションをユーザー別に抽出し、一覧データを表示します。",
    icon: "/static/images/analyze/application_member.png",
    fontIcon: "tasks",
  },
  {
    key: "application",
    title: "ITレポート(アプリ)",
    text: "使用しているアプリケーションを抽出し、一覧データを表示します。",
    icon: "/static/images/analyze/application.png",
    fontIcon: "tasks",
  },
]

export default ANALYZE_REPORT
